export default {
    data: function () {
        return {
            float_rules: [
                //v => !!v || 'Field is required',	      		      	
                //v => /^[+-]?\d+(\.\d+)?$/.test(v) || 'Type eng. number(0-9)' //no empty and float number
                //v => /^(0-[+-]?\d+(\.\d+)?|)$/.test(v) || 'Type eng. number(0-9)' // empty or float number
                v => /^$|^null$|^([+-]?\d+(\.\d+)?)$/.test(v) || 'Type eng. number(0-9)' // empty or null or float number

            ],
            dataText: '',
        }
    },

    computed: {
        upperCase: function () {

        }
    },
    methods: {

        changeFormateDMY(dates = '') {
            var regex = /[-]/; // If hase is hyphen in string then return true;
            var str = dates;
            var result = regex.test(str);
            //console.log('result = ', result);
            if (result) {
                let dt = dates.split("-");
                return dt[2] + '/' + dt[1] + '/' + dt['0'];
            }
            else{
                return dates;
            }

        },
        changeFormateYMD(dates = '') {
            //console.log('dates1 === ', dates);
            var regex = /[-]/; // If hase is hyphen in string then return true;
            var str = dates;
            var result = regex.test(str);
            //console.log('result = ', result);
            if (result) {
                return dates;
                // let dt = dates.split("-");
                // return dt[0] + '-' + dt[1] + '-' + dt['2'];
            }
            else{
                //console.log('dates2 === ', dates);
                if (dates != null) {
                    let dt = dates.split("/");
                    //console.log('dt = == =', dt);
                    if(dt != 'undefined'){
                        return dt[2] + '-' + dt[1] + '-' + dt['0'];
                    }
                }
            }           
        },

        scrollPage(top, left)
        {
            window.scrollTo({
                top: 0,
                left: 100,
                behavior: "smooth"
              });
        },

        dateStringMonth(dateV){
            var monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];

            var t = new Date(dateV);
            let dt = t.getDate() + '-' + monthShortNames[t.getMonth()] + '-' + t.getFullYear();
            //console.log('aaa = ', dt);
            return dt;
        },
    }
}


// WEBPACK FOOTER //
// ./src/mixins/dateFormate.js